module.exports = __webpack_public_path__ + "img/waves-2.1bc9c256.jpg";